import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGooglePlay } from '@fortawesome/free-brands-svg-icons';

const FirstSection = () => {
  return (
    <div>
      <div className="flex p-6 flex-col md:flex-row">
        <div className="md:order-2">
          <img
            className="w-4/5 md:w-4/5 md:transform md:-rotate-12"
            src="images/mobile.png"
            alt=""
          />
        </div>
        <div className="md:order-1 p-4 md:w-3/4">
          <h2 className="font-semibold text-2xl md:text-4xl mb-5 md:mt-5 md:mb-2 md:w-80 md:ml-10">
            Securing your mental health.
          </h2>
          <p className="text-sm leading-loose md:mt-12 md:text-lg md:ml-10 md:pr-10 md:w-4/5">
            Mental health includes our emotional, psychological, and social
            well-being. It affects how we think, feel, and act. It also helps
            determine how we handle stress, relate to others, and make healthy
            choices. Mental health is important at every stage of life, from
            childhood and adolescence through adulthood.
          </p>
          <div className="text-center md:text-left">
            <a href="https://play.google.com/store/apps/details?id=com.mithran.counsel">
              <button className="downloadBtn">
                <FontAwesomeIcon
                  icon={faGooglePlay}
                  inverse
                  className="mx-2 mt-1 text-xl"
                />
                Download Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstSection;
